'use client';

import React from 'react';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './Service.module.scss';
import { theme, Theme } from '../../store/theme';

function HeroImages({ isCustom, isCases }: { isCases?: boolean; isCustom?: boolean }) {
  const appTheme = useAtomValue<Theme>(theme);

  return (
    <div className={styles.hero__images}>
      {isCustom ? (
        <img
          className={classnames(styles.vector, styles.halo)}
          src='/media/industry_hero_halo.svg'
          alt='halo'
        />
      ) : (
        <>
          <img
            className={classnames(styles.vector, styles.vector_blur_left, {
              [styles.hidden]: appTheme === Theme.LIGHT,
            })}
            src='/media/industry_hero_ellipse_left_dark.svg'
            alt='ellipse'
          />
          <img
            className={classnames(styles.vector, styles.vector_blur_right, {
              [styles.hidden]: appTheme === Theme.LIGHT,
            })}
            src='/media/industry_hero_ellipse_right_dark.svg'
            alt='ellipse'
          />
          {!isCases && <div className={styles.hero__images__overlay} />}
          <img
            className={classnames(styles.vector, styles.vector_center)}
            src={`/media/industry_hero_center_${appTheme}.svg`}
            alt='vector'
          />
          <img
            className={classnames(styles.vector, styles.vector_left)}
            src={`/media/industry_hero_left_${appTheme}.svg`}
            alt='vector'
          />
          <img
            className={classnames(styles.vector, styles.vector_right)}
            src={`/media/industry_hero_right_${appTheme}.svg`}
            alt='vector'
          />
        </>
      ) }
    </div>
  );
}

export default HeroImages;
